import Vue from "vue";
import axios from "axios";

// import customSetting from "../../../public/config/customSetting.json";
Vue.prototype.apiUrl = self.customSetting.apiUrl;
const baseApi = self.customSetting.apiUrl;
// const getUrgentRepairController = customSetting.getUrgentRepairController;
const getUrgentRepair = self.customSetting.getUrgentRepair;
const postUrgentRepair = self.customSetting.postUrgentRepair;

export default {
  // 2-1
  getApplyDataA: (context) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`${baseApi}/${getUrgentRepair}/IintData`)
        .then((res) => {
          context.commit("GET_APPLY_DATA", res.data);
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },
  getApplyDataB: (context, prjNo) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`${baseApi}/${getUrgentRepair}/GetDraft?prj_No=${prjNo}`)
        .then((res) => {
          context.commit("GET_APPLY_DATA", res.data);
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },
  getManagerList: (context, query) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`${baseApi}/${getUrgentRepair}/GetEmp?word=${query}`)
        .then((res) => {
          context.commit("GET_MANAGER_LIST", res.data);
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },
  getSignerList: (context, query) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`${baseApi}/${getUrgentRepair}/GetEmp?word=${query}`)
        .then((res) => {
          context.commit("GET_SIGNER_LIST", res.data);
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },
  getValidCard: (context, { ld1, s_Id, id }) => {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `${baseApi}/${getUrgentRepair}/GetCardStatus?ld1=${ld1}&s_id=${s_Id}&id=${id}`
        )
        .then((res) => {
          context.commit("CHECK_CARDSTATUS_VALID", res.data);
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },
  delInsuranceFile: (context, { fileName, fileId }) => {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `${baseApi}/${getUrgentRepair}/DeleteFile?fileName=${fileName}&fileId=${fileId}`
        )
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  getValidLicense: (context, data) => {
    return new Promise((resolve, reject) => {
      axios
        .post(`${baseApi}/${postUrgentRepair}/ChkLicense`, data)
        .then((res) => {
          context.commit("CHECK_LICENSE_VALID", res.data);
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },
  submitApply: (context, data) => {
    return new Promise((resolve, reject) => {
      axios
        .post(`${baseApi}/${postUrgentRepair}/InsertData`, data)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },

  // 2-2
  getUrgentList: () => {
    return axios.get(`${baseApi}/${getUrgentRepair}/GetUrgentList`);
  },
  updUrgentStatus: (context, data) => {
    return new Promise((resolve, reject) => {
      axios
        .post(`${baseApi}/${postUrgentRepair}/UpdUrgentStatus`, data)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  getUrgentDetail: (context, prjNo) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`${baseApi}/${getUrgentRepair}/GetUrgentDetail?prjNo=${prjNo}`)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  getPrintFormInfo: (context, prjNo) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`${baseApi}/${getUrgentRepair}/GetPrintFormInfo?prjNo=${prjNo}`)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },

  // 2-3
  getViewSignOffList: () => {
    return new Promise((resolve, reject) => {
      axios
        .get(`${baseApi}/${getUrgentRepair}/ViewSignOffList`)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  getViewSignOffDetail: (context, prjNo) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`${baseApi}/${getUrgentRepair}/ViewSignOffDetail?prjNo=${prjNo}`)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  urgentRepairDownloadPdf: (context, file_id) => {
    return new Promise((resolve, reject) => {
      axios({
        url: `${baseApi}/${getUrgentRepair}/DownloadPdf?file_id=${file_id}`,
        methods: "GET",
        responseType: "blob",
      })
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
};
